/* eslint-disable react/forbid-prop-types */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import VizSensor from 'react-visibility-sensor';
import { connect } from 'react-redux';
import { TrackingContext } from '@vrbo/react-event-tracking';
import TranslationUtil from '../../utils/TranslationUtil';
import keychain from '../../assets/images/keychain.svg';
import luggage from '../../assets/images/millions-of-travlers.svg';
import shield from '../../assets/images/shield.svg';

export const LYPValuePropItems = (props) => {
    const { trigger } = useContext(TrackingContext);
    const {
        referrer,
        valueProps
    } = props;

    const { mainTitle } = valueProps;

    const handleScrollChange = (isVisible) => {
        trigger('genericEvent', {
            category: 'visibility',
            action: 'scroll',
            label: isVisible ? 'in-view' : 'out-of-view',
            referrer
        });
    };

    const renderItem = ({ title, text, image }, index) => (
        <div className="ulx-item" key={index}>
            <img className="ulx-item__image" src={image} alt="" />
            <h2 className="ulx-item__title">{title}</h2>
            <p className="ulx-item__text">{text}</p>
        </div>
    );

    return (
        <VizSensor onChange={handleScrollChange} partialVisibility resizeCheck scrollCheck>
            <div className="ulx-lyp__container" data-wdio="lyp-header">
                <h1 className="ulx-lyp-hero-text ulx-lyp-header" data-wdio="lyp-hero-text">{mainTitle}</h1>
                <div className="ulx-lyp-item__container" data-wdio="lyp-value-props">
                    {valueProps.props.map(renderItem)}
                </div>
            </div>
        </VizSensor>
    );
};

LYPValuePropItems.propTypes = {
    referrer: PropTypes.string.isRequired,
    valueProps: PropTypes.shape({
        mainTitle: PropTypes.string,
        props: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            text: PropTypes.string,
            image: PropTypes.any
        }))
    }).isRequired
};

const mapStateToProps = (state) => {
    const { app } = state;
    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    const { referrer } = app;
    return {
        referrer,
        valueProps: {
            mainTitle: translations.getTranslation('Vrbo.valueProps.title'),
            props: [
                {
                    title: translations.getTranslation('Vrbo.valueProps.prop1.title'),
                    text: translations.getTranslation('Vrbo.valueProps.prop1.text'),
                    image: keychain
                },
                {
                    title: translations.getTranslation('Vrbo.valueProps.prop2.title'),
                    text: translations.getTranslation('Vrbo.valueProps.prop2.text'),
                    image: luggage
                },
                {
                    title: translations.getTranslation('Vrbo.valueProps.prop3.title'),
                    text: translations.getTranslation('Vrbo.valueProps.prop3.text'),
                    image: shield
                }
            ]
        }
    };
};


const ConnectedLYPValuePropItems = connect(mapStateToProps)(LYPValuePropItems);
ConnectedLYPValuePropItems.displayName = 'LYPValuePropItems';

export default ConnectedLYPValuePropItems;
